import {
  Field,
  ImageField,
  LinkField,
  NextImage,
  RichText,
  Text,
} from '@sitecore-jss/sitecore-jss-nextjs';
import SectionWithCardList, {
  CardItem,
  LayoutType,
} from '../SectionWithCardList/SectionWithCardList';
import { ComponentProps } from 'lib/component-props';
import { ButtonVariantType, GridAlignType, ImagePositionType } from 'components/shared/Card/Card';

type SelectField<T> = {
  fields: {
    value: Field<T>;
  };
};

type CardListProps = {
  fields: {
    cardTitle: Field<string>;
    cardDescription: Field<string>;
    cardImage: ImageField;
    cardLink: LinkField;
    label: Field<string>;
    metaText: Field<string>;
    fullWidth: Field<boolean>;
    removeImagePadding: Field<boolean>;
    imagePosition: SelectField<string>;
    linkVariant: {
      fields: {
        name: Field<string>;
      };
    };
  };
};

type Props = ComponentProps & {
  fields: {
    title: Field<string>;
    subTitle: Field<string>;
    cardList: CardListProps[];
    backgroundColor: Field<string>;
    columnSize: Field<string>;
    cardBorderRadius: Field<string>;
    imageBorderRadius: Field<string>;
    buttonAllignment: SelectField<string>;
    isLargeButton: Field<boolean>;
    imageHeight: Field<string>;
    layout: SelectField<string>;
  };
};

function UnderStandClinicalResearch({ fields }: Props) {
  const title = <Text field={fields.title} />;
  const description = <RichText field={fields.subTitle} />;
  const cardList: CardItem[] = fields.cardList.map((x) => ({
    title: x.fields.cardTitle.value ? <RichText field={x.fields.cardTitle} /> : null,
    description: x.fields.cardDescription.value ? (
      <RichText field={x.fields.cardDescription} />
    ) : null,
    image: x.fields?.cardImage?.value ? (
      <NextImage
        loading="lazy"
        field={x.fields?.cardImage}
        width={200}
        height={200}
        alt="card cover"
      />
    ) : null,
    button: x.fields.cardLink,
    label: <Text field={x.fields?.label} />,
    metaText: <Text field={x.fields?.metaText} />,
    fullWidth: x.fields?.fullWidth?.value,
    removeImagePadding: x.fields?.removeImagePadding?.value,
    imagePosition: x.fields?.imagePosition?.fields?.value?.value as ImagePositionType,
    buttonVariant: x.fields?.linkVariant?.fields.name.value as ButtonVariantType,
  }));
  const columnSize = parseInt(fields.columnSize?.value) || 3;
  const background = fields.backgroundColor?.value || '#F7F8FA';
  const imageBorderRadius = fields.imageBorderRadius?.value;
  const cardBorderRadius = fields.cardBorderRadius?.value;
  const buttonAlignment = fields.buttonAllignment?.fields?.value?.value as GridAlignType;
  const largeButton = fields?.isLargeButton?.value;
  const imageheight = fields?.imageHeight?.value;
  const layout = fields?.layout?.fields?.value?.value as LayoutType;

  return (
    <SectionWithCardList
      title={title}
      description={description}
      cards={cardList}
      columnSize={columnSize}
      background={background}
      imageBorderRadius={imageBorderRadius}
      imageHeight={imageheight}
      cardBorderRadius={cardBorderRadius}
      buttonAlign={buttonAlignment}
      buttonFullWidth={largeButton}
      layout={layout}
    />
  );
}

export default UnderStandClinicalResearch;
